import CryptoJS from 'crypto-js';
export default CryptoJS;
